import React, { useEffect } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import logo from "../../assests/spllogo.jpg"; // Your clinic/hospital logo
import { useDispatch, useSelector } from "react-redux";
import { getSpecialPackages } from "../../Redux/Slice/SpecialPackage";

// const packageData = [
//   {
//     id: 1,
//     title: "Heart Checkup",
//     shortDescription: "Basic heart screening and consultation.",
//     fullDescription:
//       "Includes ECG, Echo, Blood pressure evaluation, and Cardiologist consultation.",
//     price: "₹1,999",
//     clinicName: "City Heart Center",
//   },
//   {
//     id: 2,
//     title: "Diabetic Care",
//     shortDescription: "Early detection and diabetes management package.",
//     fullDescription:
//       "Includes fasting blood sugar, HbA1c, insulin levels, and endocrinologist review.",
//     price: "₹1,499",
//     clinicName: "Metro Diabetes Clinic",
//   },
//   // Add more packages as needed
// ];

const SpecialPackages = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSpecialPackages());
  }, [dispatch]);

  const { items } = useSelector((state) => state.packages);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Special Hospital Packages</h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "1.5rem",
          flexWrap: "wrap",
          marginTop: "2rem",
        }}
      >
        {items?.data?.map((pkg) => (
          <Card
            key={pkg.id}
            title={
              <div>
                <img src={logo} alt="logo" height="50px" />
                {/* <h6 style={{ marginTop: "-20px", color: "rgb(132, 214, 231)" }}>
                  TRUST DOC
                </h6> */}
                <div
                  style={{
                    fontWeight: "bold",
                    marginTop: "0.5rem",
                    fontSize: "14px",
                  }}
                >
                  {pkg.packageFacility}
                </div>
                {/* <div
                  style={{
                    fontWeight: "bold",
                    marginTop: "0.5rem",
                    fontSize: "14px",
                  }}
                >
                  {pkg.packageName}
                </div> */}
              </div>
            }
            subTitle={<div>{pkg.packageName}</div>}
            // subTitle={<div>{pkg.packageDescrption}</div>}
            style={{
              width: "280px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              paddingBottom: "0.5rem",
            }}
            footer={
              <Button
                label="View"
                icon="pi pi-eye"
                onClick={() =>
                  navigate(`/special-packages/${pkg.packageId}`, { state: pkg })
                }
                className="p-button-sm"
              />
            }
          >
            <p
              style={{
                fontWeight: "bold",
                margin: "0.5rem 0 0.3rem",
                color: "#0e102d",
              }}
            >
              Price: {pkg.amount}
            </p>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default SpecialPackages;
